import React, { useState, useEffect } from 'react';
import { withRouter, useParams } from 'react-router-dom';
import { Segment } from '@fxtr/i18n';
import moment from 'moment';
import { message, Modal } from 'antd';
import Loading from '$app/shared/components/Loading';
import { useMaiaT } from '$app/i18n/useMaiaT';
import Menu from '../components/Menu';
import GaragePageHeader from '../components/GaragePageHeader';
import makeGarageFrom from '../components/GarageForm';
import { getGarageById, putGarageById } from './actions';
import { mapPropsToFields, getErrorMessages } from '../../utils';
import { normalizeOptionalStrings } from '../../utils/normalizeOptionalStrings';
import { normalizePhoneFields } from '../../utils/phoneValidation';

const GarageEditForm = makeGarageFrom(mapPropsToFields);

export function GarageEditPage(props) {
  const t = useMaiaT();
  const { history } = props;
  const { garageId } = useParams();
  const [state, setState] = useState({
    garage: /** @type {Record<string, any> | null} */ (null),
    loading: false,
  });

  useEffect(() => {
    if (!state.garage && garageId) {
      getGarageById(garageId).then((garage) => setState((st) => ({ ...st, garage })));
    }
  });

  if (!garageId || !state.garage) return <Loading />;

  const { garage } = state;

  function onSubmit(e, form) {
    form.validateFieldsAndScroll(async (err, values) => {
      if (err) return;

      // The form is controlled by mapPropsToFields(initialValue). Flipping
      // `loading` re-renders and would snap every field back to the garage
      // loaded before this edit until the response arrives. Seed the submitted
      // values first so the field keeps what was typed for the whole save.
      const submittedGarage = {
        ...garage,
        ...normalizeOptionalStrings(normalizePhoneFields(values)),
      };

      setState((st) => ({ ...st, loading: true, garage: submittedGarage }));
      try {
        const res = await putGarageById(garageId, submittedGarage);
        setState((st) => ({ ...st, loading: false, garage: res }));
        message.success(t('maia.garageInfo.updateSuccess', 'Garage updated successfully'));
      } catch (error) {
        Modal.error({
          title: t('maia.garageInfo.updateFailedTitle', 'Garage update failed'),
          content: (
            <div>
              {getErrorMessages(error).map((msg) => (
                <p style={{ fontSize: 12, marginBottom: 5 }} key={msg[0]}>
                  {msg}
                </p>
              ))}
            </div>
          ),
        });
        setState((st) => ({ ...st, loading: false }));
      }
    });
  }
  if (state.garage) {
    const flag = state.garage.segment === Segment.Fixter_UK ? '🇬🇧' : '🇫🇷';
    document.title = `${flag} ${state.garage?.businessName}`;
  }
  return (
    <>
      <GaragePageHeader history={history} name={state.garage?.businessName} garageId={garageId} />
      <p style={{ paddingLeft: 15 }}>
        {t('maia.garageInfo.createdLine', 'Garage created: {date}', {
          date: moment(garage.creationDateTime).format('MMMM Do YYYY, h:mm:ss a'),
        })}
      </p>
      <Menu selectedItem="garageInfo" garageId={garageId} history={history} />
      <GarageEditForm
        onSubmit={onSubmit}
        initialValue={state.garage}
        loading={state.loading}
        canEditPremiumMembership={false}
      />
    </>
  );
}

export default withRouter(GarageEditPage);
